"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const constants_1 = require("utils/constants");
const app_types_1 = require("./app.types");
const appReducer = (0, toolkit_1.createReducer)(app_types_1.initialState, {
    [app_types_1.appTypes.SWITCH_APP_THEME]: (state, action) => {
        const { appTheme } = action.payload;
        localStorage.setItem(constants_1.localStorageKey.themeApp, appTheme);
        return Object.assign(Object.assign({}, state), { appTheme: appTheme });
    },
    [app_types_1.appTypes.APP_SELECT_MENU]: (state, action) => {
        var _a;
        const { menu, subMenu } = action.payload;
        const menuFind = state.sidebar.menu.find(m => m.menu === menu);
        const menuSelected = {
            menu,
            pathMenu: (menuFind === null || menuFind === void 0 ? void 0 : menuFind.path) || constants_1.pathList.dashboard.path,
            subMenu: subMenu ? undefined : subMenu,
            pathSubMenu: subMenu ? undefined : (_a = menuFind === null || menuFind === void 0 ? void 0 : menuFind.subMenu[0]) === null || _a === void 0 ? void 0 : _a.path,
        };
        if (subMenu) {
            return Object.assign(Object.assign({}, state), { sidebar: Object.assign(Object.assign({}, state.sidebar), { selectedMenu: menuSelected, menu: state.sidebar.menu.map(menuItem => {
                        if (menuItem.menu === menu) {
                            return Object.assign(Object.assign({}, menuItem), { selected: true, subMenu: menuItem.subMenu.map(subMenuItem => {
                                    if (subMenuItem.subMenuName === subMenu) {
                                        return Object.assign(Object.assign({}, subMenuItem), { selected: true });
                                    }
                                    return Object.assign(Object.assign({}, subMenuItem), { selected: false });
                                }) });
                        }
                        return Object.assign(Object.assign({}, menuItem), { selected: false, subMenu: menuItem.subMenu.map(subMenuItem => {
                                return Object.assign(Object.assign({}, subMenuItem), { selected: false });
                            }) });
                    }) }) });
        }
        return Object.assign(Object.assign({}, state), { sidebar: Object.assign(Object.assign({}, state.sidebar), { selectedMenu: menuSelected, menu: state.sidebar.menu.map(menuItem => {
                    if (menuItem.menu === menu) {
                        return Object.assign(Object.assign({}, menuItem), { selected: true, subMenu: menuItem.subMenu.map((subMenuItem, index) => {
                                if (index === 0) {
                                    return Object.assign(Object.assign({}, subMenuItem), { selected: true });
                                }
                                return Object.assign(Object.assign({}, subMenuItem), { selected: false });
                            }) });
                    }
                    return Object.assign(Object.assign({}, menuItem), { selected: false });
                }) }) });
    },
    [app_types_1.appTypes.TOGGLE_SIDEBAR]: (state) => {
        return Object.assign(Object.assign({}, state), { sidebar: Object.assign(Object.assign({}, state.sidebar), { status: state.sidebar.status === 'expand' ? 'colapse' : 'expand' }) });
    },
});
exports.default = appReducer;
